module.exports = __webpack_public_path__ + "img/officialAccounts.1951d95a.png";